module.exports = __webpack_public_path__ + "img/document-sketch.5ad6665b.svg";